<div class="policy">
  <h1>Cookie Policy</h1>
  <p class="meta">Last updated: {{ lastUpdated }}</p>

  <p>
    This Cookie Policy explains how our ordering website uses cookies and
    similar technologies. Some are essential for the site to function. Others
    (like analytics) are optional.
  </p>

  <h2>What are cookies?</h2>
  <p>
    Cookies are small text files stored on your device. Similar technologies
    include local storage and session storage used by your browser.
  </p>

  <h2>Essential cookies & storage (always on)</h2>
  <p>We use essential storage to provide core functionality such as:</p>
  <ul>
    <li>Keeping your basket and checkout working</li>
    <li>Remembering basic preferences (e.g. chosen service type)</li>
    <li>Security and fraud prevention</li>
  </ul>

  <h2>Analytics cookies (optional)</h2>
  <p>
    With your permission, we use Google Analytics to measure traffic and improve
    the site. Analytics data is collected in aggregate and helps us understand
    which pages are used and how the site performs.
  </p>

  <h2>Information entered during checkout</h2>
  <p>
    When you place an order, you may enter details such as your name, email
    address and phone number so the restaurant can fulfil your order. These
    details are used to process the order and are not stored on your device as
    cookies by us.
  </p>

  <h2>Managing your preferences</h2>
  <p>
    You can change your cookie preferences at any time by clearing your browser
    storage for this site. This will cause the cookie banner to reappear.
  </p>

  <h2>Contact</h2>
  <p>
    If you have questions about this policy, please contact the restaurant
    directly.
  </p>

  <div class="actions">
    <button type="button" class="btn" (click)="clearConsent()">
      Reset cookie preferences
    </button>
  </div>
</div>
